import React from 'react'
import { Avatar as MuiAvatar, AvatarProps as MuiAvatarProps } from '@mui/material'
import { styled } from '@mui/material/styles'

export type AvatarProps = MuiAvatarProps

const Root = styled(MuiAvatar)({
  backgroundColor: 'var(--ds-hover)',
  color: 'var(--ds-ink)',
  fontWeight: 600,
})

export const Avatar = React.forwardRef<HTMLDivElement, AvatarProps>(function Avatar(props, ref) {
  return <Root ref={ref} {...props} />
})
